define('all/counter',['jquery'], function($) {
	'use strict';

	// TODO: rewrite all of this, rethink/restructure

	// new window.Counter('#cnt-player-bar #player-points');
	// $('#cnt-player-bar #player-points').data('value', 1337);

	// new window.Counter('#cnt-player-bar #total-balance', {decimalPoint: ',', precision: 2, prefix: '$'});

	// options object:
	//    precision is how many decimal places, usually 2 or 0, default: 0
	//    decimalPoint is usually ',' or '.', default: '.' (not used at precision 0)
	//    thousandSeparator separates whole part every third, default: ''
	//    prefix is added before, default: ''
	//    suffix is added after, default: ''
	var Counter = function(element, options) {
		if (typeof element === 'undefined') {
			return;
		}
		var $element = $(element);
		options = typeof options !== 'undefined' ? options : {};
		var precision = typeof options.precision !== 'undefined' ? options.precision : 0;
		var decimalPoint = typeof options.decimalPoint !== 'undefined' ? options.decimalPoint : '.';
		var thousandSeparator = typeof options.thousandSeparator !== 'undefined' ? options.thousandSeparator : '';
		var prefix = typeof options.prefix !== 'undefined' ? options.prefix : '';
		var suffix = typeof options.suffix !== 'undefined' ? options.suffix : '';

		// how large fraction will get added of the difference each time
		// larger number means slower counting
		var fraction = 3;

		// update frequency of callback
		var frequencyMs = 150;

		// when the difference is smaller than this, just set the value and finish the animation
		var skipBelowDiff = Math.pow(10, precision) / fraction;

		$element.data('oldValue', Number($element.text()) || 0);
        var refreshIntervalId = window.setInterval(update, frequencyMs);
		$element.data('refreshIntervalId', refreshIntervalId);
		update(refreshIntervalId);

		function getRoundedValue(value) {

			var val = Math.round(value * Math.pow(10, precision)).toString();

			while(val.length < precision + 1) {
				val += '0';
			}

			var wholeLength = val.length - precision;
			var wholePart = val.substring(0, wholeLength);

			// split at thousandSeparator
			for (var i = 0; i < Math.floor((wholePart.length - (1 + i)) / 3); i++) {
				wholePart = wholePart.substring(0, wholePart.length - (4 * i + 3)) +  thousandSeparator + wholePart.substring(wholePart.length - (4 * i + 3));
			}

			if (precision === 0) {
				return wholePart;
			}

			return wholePart + decimalPoint + val.substring(wholeLength, val.length);
		}

		function update(refreshIntervalId) {
			var value = Number($element.data('oldValue')) || 0;
			var goalValue = Number($element.data('value')) || value;

            if(value === goalValue){
                if( typeof $element.data('refreshIntervalId') === 'undefined'){
                    window.clearInterval(refreshIntervalId);
                }
                else{
                    window.clearInterval($element.data('refreshIntervalId'));
                }
                return;
            }

			var diff = goalValue - value;
			var thisTime = diff / fraction;
			if (Math.abs(diff) < skipBelowDiff) {
				thisTime = diff;
			}
			value += thisTime;

			$element.data('oldValue', value);
			$element.text(prefix + getRoundedValue(value) + suffix);
		}
	};

	return Counter;
});

